import React from 'react'
import {
  View,
  Text,
  Document,
  Page,
  Font,
  Image,
  Svg,
  Path,
  StyleSheet,
} from '@react-pdf/renderer'
import QRCode from 'qrcode-svg'
import {pharmacyChainUrl} from '../../Utils/constants'
import {_formatPrice, calcPageBreak} from '../../Utils/tools'
import NunitoRegular from '../../assets/fonts/Nunito-Regular.ttf'
import NunitoBold from '../../assets/fonts/Nunito-Bold.ttf'
import NunitoLight from '../../assets/fonts/Nunito-Light.ttf'

Font.registerHyphenationCallback((word) => [word])

Font.register({
  family: 'Nunito',

  fonts: [
    {
      src: NunitoRegular,
      fontWeight: 'light',
    },
    {
      src: NunitoBold,
      fontWeight: 'bold',
    },
    {
      src: NunitoLight,
      fontWeight: 'ultralight',
    },
  ],
})

const styles = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingHorizontal: 8,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  footerContainer: {
    marginTop: 'auto',
    marginBottom: 10,
    flexDirection: 'row',
    display: 'flex',
    flexFlow: 'row',
    width: 650,
  },
  footerText: {
    fontSize: 10,
    fontFamily: 'Nunito',
    fontWeight: 'light',
    textAlign: 'left',
    paddingHorizontal: 16,
    with: 650,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
    marginHorizontal: 12,
    marginBottom: 4,
    paddingVertical: 2,
    paddingHorizontal: 2,
    width: 100,
    height: 32,
  },
  logo: {
   
  },
  InfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 744,
    marginVertical: 0,
    marginHorizontal: 12,
    paddingBottom: 0,
    paddingTop: 0,
  },
  title: {
    fontSize: 16,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    lineHeight: 1.9,
  },
  subtitle: {
    fontSize: 12,
    fontFamily: 'Nunito',
    fontWeight: 'light',
    maxWidth: 364,
    lineHeight: 1.4,
    marginBottom: 8,
    letterSpacing: 0.3,
  },
  qr: {
    display: 'flex',
    width: 120,
    height: 120,
    alignItems: 'center',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    order: 2,
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    order: 1,
  },
  productContainer: {
    minHeight: 90,
    maxWidth: 677,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#dde0ec',
    marginHorizontal: 8,
    marginVertical: 0,
    paddingVertical: 0,
  },
  productText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    lineHeight: 1.4,
    marginTop: 12,
    color: '#282E55',
  },
  productTitle: {
    fontSize: 14,
    lineHeight: 1.9,
    marginHorizontal: 16,
    marginTop: 18,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    color: '#282E55',
  },
  productCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
    paddingTop: 0,
    paddingBottom: 5,
  },
  cardRight: {
    display: 'flex',
    alignItems: 'center',
    order: 1,
  },
  cardLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    order: 2,
  },
  imgProduct: {
    display: 'flex',
    height: 45,
    paddingRight: 5,
  },
  subtitleCard: {
    fontSize: 12,
    fontFamily: 'Nunito',
    maxWidth: 344,
    lineHeight: 1.3,
  },
  priceCard: {
    minHeight: 80,
    maxHeight: 90,
    maxWidth: 178,
    minWidth: 178,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#dde0ec',
    marginHorizontal: 4,
    marginVertical: 4,
    paddingBottom: 8,
    paddingTop: 8,
  },
  pricesContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 744,
    paddingBottom: 16,
    paddingTop: 4,
    marginHorizontal: 4,
    paddingHorizontal: 6,
  },
  pricesHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#dde0ec',
  },
  imgPharmacy: {
    display: 'flex',
    alignItems: 'center',
    order: 1,
    width: 34,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 3,
    objectFit: 'contain',
  },
  pricesContent: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 6,
  },
  priceFull: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    paddingHorizontal: 6,
  },
  priceFraction: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    paddingTop: 4,
    paddingHorizontal: 6,
    marginBottom: 4,
    paddingBottom: 2,
  },
  normalText: {
    fontSize: 12,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    maxWidth: 344,
    lineHeight: 1.9,
    color: 'rgb(40, 46, 85)',
  },
  thinText: {
    fontSize: 12,
    fontWeight: 'ultralight',
    fontFamily: 'Nunito',
    lineHeight: 1.6,
  },
})

function QuotationPDF(props) {
  const {pharmacyPrices} = props
  const qrcode = new QRCode({
    content: props.link,
    width: 120,
    height: 120,
    join: true,
    ecl: 'Q',
    container: 'svg-viewbox',
  })
  const qrCodeSvgString = qrcode.svg({container: 'none'})
  const pathStartIndex = qrCodeSvgString.indexOf(' d="') + 4

  const pathEndIndex = qrCodeSvgString.indexOf('"', pathStartIndex)
  const qrCodeSvgPathString = qrCodeSvgString.slice(
    pathStartIndex,
    pathEndIndex,
  )
  const productList = [
    {
      ...props.product,
      priceList: pharmacyPrices
    },
  ]
  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <View style={styles.headerContainer} fixed>
          <Image
            style={styles.logo}
            src="https://s3.us-east-2.amazonaws.com/s3.yapp/logo-yapp.png"
          />
        </View>
        <View style={styles.InfoContainer}>
          <View style={styles.left}>
            <Text style={styles.title}>
              Ahorra hasta un 60% en tus medicamentos
            </Text>
            <Text style={[styles.subtitle, {flexWrap: 'wrap'}]}>
              Compra tus medicamentos al mejor precio disponible en múltiples
              farmacias, deja programada tus compras y olvídate de ir a la
              farmacia todos los meses, nosotros lo hacemos por ti.
            </Text>
            <Text style={styles.title}>
              Escanear el código QR para acceder a Yapp.
            </Text>
          </View>
          <View style={styles.right}>
            <Svg style={styles.qr}>
              <Path d={qrCodeSvgPathString} fill="black" />
            </Svg>
          </View>
        </View>
        <Text style={styles.productTitle}>Tus medicamentos recetados</Text>
        {productList.map((product) => (
          <View wrap>
            <View style={styles.productContainer}>
              <View style={styles.productCard}>
                <View style={styles.cardRight}>
                  <Image
                    style={styles.imgProduct}
                    source={{
                      uri: product.product_logo,
                      method: 'GET',
                      headers: {'Cache-Control': 'no-cache'},
                      body: '',
                    }}
                  />
                </View>
                <View style={styles.cardLeft}>
                  <Text style={styles.productText}>{product.product_name}</Text>
                  <Text
                    style={{
                      fontFamily: 'Nunito',
                      fontWeight: 'light',
                      fontSize: 12,
                      lineHeight: 1.6,
                      color: '#282E55',
                    }}>
                    {product.formula_name}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Nunito',
                      fontWeight: 'light',
                      fontSize: 12,
                      lineHeight: 1.6,
                      color: '#282E55',
                    }}>
                    {product.presentation}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Nunito',
                      fontWeight: 'light',
                      fontSize: 12,
                      lineHeight: 1.6,
                      color: '#282E55',
                    }}>
                    {product.laboratory_name}
                  </Text>
                </View>
              </View>
            </View>
            <Text style={styles.productTitle}>Compra única en farmacias</Text>
            <View style={styles.pricesContainer} wrap>
              {product.priceList.map((price, i) => (
                <View
                  style={[
                    styles.priceCard,
                    {marginBottom: calcPageBreak(i) ? 100 : 8},
                  ]}>
                  <View style={styles.pricesHeader}>
                    <Image
                      style={styles.imgPharmacy}
                      source={{
                        uri: pharmacyChainUrl + price.pharmacyChainLogo,
                        method: 'GET',
                        headers: {'Cache-Control': 'no-cache'},
                        body: '',
                      }}
                    />
                    <Text
                      style={{
                        flex: 1,
                        flexWrap: 'wrap',
                        fontSize: '12',
                        fontFamily: 'Nunito',
                        fontWeight: 'bold',
                        color: 'rgb(40, 46, 85)',
                      }}>
                      {price.pharmacyChainName}
                    </Text>
                  </View>
                  <View style={styles.pricesContent}>
                    <View
                      style={[
                        styles.priceFull,
                        {justifyContent: 'space-between'},
                      ]}>
                      <Text style={styles.normalText}>Precio lista</Text>
                      <Text style={styles.normalText}>
                        {_formatPrice(price.listPrice)}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[
                      styles.priceFraction,
                      {justifyContent: 'space-between'},
                    ]}>
                    <Text
                      style={[styles.thinText, {color: 'rgb(118,118,118)'}]}>
                      Precio fraccionado
                    </Text>
                    <Text
                      style={[styles.thinText, {color: 'rgb(118,118,118)'}]}>
                      {_formatPrice(price.fractionalPrice)}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        ))}

        <View style={styles.footerContainer}>
          <Text style={styles.footerText}>
            *Todos los precios y disponibilidad están sujetos a cambios según
            las farmacias y la comuna seleccionada.
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default QuotationPDF
